module.exports = __webpack_public_path__ + "static/media/logomax3dpro.93483e03.png";